export function firstDefined(obj, keys, fallback) {
  if (!obj) return fallback;
  for (const key of keys) {
    if (obj[key] != null) return obj[key];
  }
  return fallback;
}

export function compactParams(params) {
  const next = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value != null && value !== '') next[key] = value;
  });
  return next;
}

export function asItems(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return data.items || data.events || data.messages || data.documents || data.payments || [];
}
